import bus, { eventNames } from '@/lib/eventBus'

export const showSnackbarMessage = (errType, errMessage) => {
  bus.$emit(eventNames.SHOW_SNACKBAR, {
    color: errType,
    text: errMessage
  })
}
